/**
 * Project : workspace
 * File    : InventoryCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.stock.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.product_color.ProductColorViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.size.SizeViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.uom.UOMViewModel
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import theme.ThemeColor


/**
 * Represents the inventory card class.
 */


class InventoryCard {
    var inventory: Inventory? = null
    var onClick: ((Inventory) -> Unit) ? = null
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val color = remember<MutableState<String?>> { mutableStateOf(null) }
        val uom = remember<MutableState<String?>> { mutableStateOf(null) }
        val size = remember<MutableState<String?>> { mutableStateOf(null) }
        LaunchedEffect(key1 = Unit) {
            ProductColorViewModel(myBusiness.value).getColorById(inventory?.ColorID) { colorFromDb ->
                color.value = colorFromDb?.Name
            }
            UOMViewModel(myBusiness.value).getUOMById(inventory?.UOMID) { uomFromDb -> uom.value = uomFromDb?.Name }
            SizeViewModel(business = myBusiness.value).getSizeById(inventory?.SizeID) { sizeFromDb ->
                size.value = sizeFromDb?.Name
            }
        }

        val tableHeader = listOf("Color", "UoM", "Size", "Qty")
        val tableCell = listOf(color.value, uom.value, size.value, inventory?.Quantity)

        Column(
            modifier = Modifier
                .wrapContentHeight()
                .wrapContentWidth()
                .padding(start = 16.dp, end = 8.dp, bottom = 8.dp)
                .shadow(3.dp)
                .background(ThemeColor.shared().cardBackground)
                .zIndex(1f)
                .clickable { onClick!!(inventory!!) },
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().wrapContentHeight(),
            ) {
                Column(
                    modifier = Modifier.fillMaxHeight().fillMaxWidth().weight(3f),
                ) {
                    Text(
                        text = "${inventory?.Name}",
                        maxLines = 4,
                        overflow = TextOverflow.Ellipsis,
                        fontSize = 18.sp,
                        fontWeight = FontWeight(600),
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(32.dp)
                            .background(ThemeColor.shared().rowHeadingColor)
                    )
                }
                Column(
                    modifier = Modifier.fillMaxHeight().fillMaxWidth().weight(1f),
                ) {
                    Text(
                        text = "${inventory?.ProductPrice?.currency?.symbol} ${inventory?.ProductPrice?.FinalPrice}",
                        fontWeight = FontWeight(600),
                        color = ThemeColor.shared().PrimaryColor,
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(32.dp)
                            .background(ThemeColor.shared().rowHeadingColor)
                    )
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth().wrapContentHeight(),
            ) {
                // Iterate over columns in each row
                for (columnName in tableHeader) {
                    Column(
                        modifier = Modifier.fillMaxHeight().fillMaxWidth().weight(0.2f),
                    ) {
                        Text(
                            text = columnName,
                            maxLines = 4,
                            overflow = TextOverflow.Ellipsis,
                            fontSize = 16.sp,
                            fontWeight = FontWeight(500),
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(30.dp)
                                .background(ThemeColor.shared().rowBackgroundColor)
                        )
                    }
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth().wrapContentHeight(),
            ) {
                for (cell in tableCell) {
                    Column(
                        modifier = Modifier.fillMaxHeight().fillMaxWidth().weight(0.2f),
                    ) {
                        Text(
                            text = "${cell}",
                            maxLines = 4,
                            overflow = TextOverflow.Ellipsis,
                            fontSize = 16.sp,
                            fontWeight = FontWeight(400),
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(30.dp)
                        )
                    }
                }
            }
        }
    }
}